import api from '@/lib/axios';

export interface OssPresignedUrlRequest {
  filename: string;
  contentType?: string;
}

export interface OssPresignedUrlResponse {
  uploadUrl: string;
  objectName: string;
  viewUrl: string;
}

export interface RespBody<T> {
  errorCode: string;
  value: string;
  data: T;
}

/**
 * 获取 OSS 上传预签名 URL
 */
export const ossApi = {
  /**
   * 获取预签名 URL，用于直传文件到 OSS
   */
  generatePresignedUrl: async (
    request: OssPresignedUrlRequest,
  ): Promise<OssPresignedUrlResponse> => {
    // axios 拦截器已经返回了 data 字段，所以 response 直接就是 OssPresignedUrlResponse
    const response = await api.post<OssPresignedUrlResponse>(
      '/lowcode-business/api/oss/generatePresignedUrl',
      request,
    );

    return response as unknown as OssPresignedUrlResponse;
  },

  /**
   * 上传文件到 OSS（使用预签名 URL）
   */
  uploadFile: async (uploadUrl: string, file: File): Promise<void> => {
    await fetch(uploadUrl, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });
  },
};
